module.exports = __webpack_public_path__ + "static/media/trophy.b9917dcb.svg";